import { render, staticRenderFns } from "./WsHeader.vue?vue&type=template&id=cb8e3d08"
import script from "./WsHeader.vue?vue&type=script&lang=js"
export * from "./WsHeader.vue?vue&type=script&lang=js"
import style0 from "./WsHeader.vue?vue&type=style&index=0&id=cb8e3d08&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports